import { Accordion, AccordionSummary, Box, styled } from '@mui/material';

export const ComponentNameWrapper = styled(Box)`
  overflow: hidden;
`;

export const DateWrapper = styled(Box)`
  margin-top: 10px;
  margin-right: 20px;
`;

export const StyledAccordion = styled(Accordion)`
  margin: 0;
  width: 100%;
`;

export const Summary = styled(AccordionSummary)(
  ({ theme }) => `
        border-bottom: 1px solid ${theme.palette.brand.black};
        &.Mui-disabled {
          opacity: 1;
        }
    `,
);
